import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=5fc1e7b8&scoped=true&"
import script from "./answers.vue?vue&type=script&lang=js&"
export * from "./answers.vue?vue&type=script&lang=js&"
import style0 from "./answers.vue?vue&type=style&index=0&id=5fc1e7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1e7b8",
  null
  
)

export default component.exports